@if (!isOnAccountsPage) {
  <div [ngClass]="isMobile ? 'toggle' : 'toggle-container'"
    id="quotesSubesctionsTogglesContainer">
    <ds-button-toggle-legacy (onClick)="onTabChange($event)"
      [toggleValues]="isMobile ? mobileToggleValues : toggleValues" size="large"
      type="outlined" [selectedIndex]="activeTabIndex" [isMultipleSelection]="false">
    </ds-button-toggle-legacy>
  </div>
}
